/*eslint-disable*/
export default {
    data () {
        return {
            statuses: [
                'active',
                'archived'
            ],
            statusNames: {
                active: this.$i18n.t('fields.fields_statusActive'),
                archived: this.$i18n.t('fields.fields_statusArchived'),
                notActive: this.$i18n.t('fields.fields_statusUpcoming'),
            }
        }
    },
    methods: {
        getStatusName(status) {
            return this.statusNames[status];
        }
    }
}
